export default __webpack_public_path__ + "images/870d830b4407c8d1dccd8d107fb385ba.png";